var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.1 0h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.1c0 9.749 11.25 15.45 19.12 9.7l124.9-93.7h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 0 447.1 0zM127.1 239.1c-17.75 0-32-14.25-32-31.1s14.25-31.1 32-31.1s32 14.25 32 31.1S145.7 239.1 127.1 239.1zM255.1 239.1c-17.75 0-32-14.25-32-31.1s14.25-31.1 32-31.1s32 14.25 32 31.1S273.7 239.1 255.1 239.1zM383.1 239.1c-17.75 0-32-14.25-32-31.1s14.25-31.1 32-31.1s32 14.25 32 31.1S401.7 239.1 383.1 239.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageDots);
export default __webpack_public_path__ + "static/media/message-dots.36ea70b30a16bca092c06f6e14b44086.svg";
export { ForwardRef as ReactComponent };